module.exports = __webpack_public_path__ + "img/8.6eb92743.png";